import request from '../../../../api/request';
import { PaginationRequestType } from '../../../../types/paginationRequestType';

const PARTNERSHIPS = {
  BASE: '/maintainers-portal/admission-and-enrollments/partnerships',
  BY_ID: (id: number) =>
    `/maintainers-portal/admission-and-enrollments/partnerships/${id}`,
  TOGGLE: (id: number) =>
    `/maintainers-portal/admission-and-enrollments/partnerships/${id}/toggle-active`,
  TYPES:
    '/maintainers-portal/admission-and-enrollments/partnerships/form-data/types',
  PERIODS:
    '/maintainers-portal/admission-and-enrollments/partnerships/form-data/periods',
  OFFERS:
    '/maintainers-portal/admission-and-enrollments/partnerships/form-data/offers',
};

export interface Partnership {
  id: number;
  name: string;
  code: string;
  description?: string;
  isActive: boolean;
  typeId: string;
  partnershipType?: string;
  discountValue: number;
  discountType: string;
  applyAutomatically?: boolean;
  discounts?: PartnershipDiscountItem[];
}

export interface PartnershipDiscountItem {
  id: number;
  periodId: number;
  studyPlanVersionOfferId: number;
  discountPercentage: number;
  period?: {
    id: number;
    name: string;
    code: string;
    startDate: string;
    endDate: string;
  };
  studyPlanVersionOffer?: StudyPlanVersionOfferItem;
}

export interface StudyPlanVersionOfferItem {
  id: number;
  studyPlanVersion?: {
    id: number;
    studyPlan?: {
      id: number;
      name: string;
    };
  };
  campus?: {
    id: number;
    name: string;
  };
  schedule?: {
    id: number;
    name: string;
  };
}

export interface PeriodItem {
  id: number;
  name: string;
  code: string;
  startDate: string;
  endDate: string;
}

export interface CreatePartnershipData {
  name: string;
  code?: string;
  partnershipType?: string;
  description?: string;
  applyAutomatically?: boolean;
  discounts?: {
    periodId: number;
    studyPlanVersionOfferId: number;
    discountPercentage: number;
  }[];
}

export type PartnershipsListResponse = PaginationRequestType<Partnership>;

export const getPartnershipsRequest = (
  items: number = 10,
  page: number = 0,
) => {
  return request<PartnershipsListResponse>(PARTNERSHIPS.BASE, {
    params: { items_per_page: items, page },
  });
};

export const getPartnershipByIdRequest = (id: number) => {
  return request<Partnership>(PARTNERSHIPS.BY_ID(id));
};

export const createPartnershipRequest = (data: CreatePartnershipData) => {
  return request<Partnership>(PARTNERSHIPS.BASE, {
    method: 'post',
    data,
  });
};

export const updatePartnershipRequest = (
  id: number,
  data: Partial<CreatePartnershipData>,
) => {
  return request<Partnership>(PARTNERSHIPS.BY_ID(id), {
    method: 'put',
    data,
  });
};

export const togglePartnershipActiveRequest = (id: number) => {
  return request<Partnership>(PARTNERSHIPS.TOGGLE(id), {
    method: 'patch',
  });
};

export const deletePartnershipRequest = (id: number) => {
  return request<void>(PARTNERSHIPS.BY_ID(id), {
    method: 'delete',
  });
};

export interface EbTypeItem {
  id: string;
  name: string;
  category: string;
}

export const getBenefitTypesRequest = (category?: string) => {
  return request<EbTypeItem[]>(PARTNERSHIPS.TYPES, {
    params: category ? { category } : undefined,
  });
};

export const getPeriodsForPartnershipRequest = (
  yearFilter: string = 'last5',
) => {
  return request<PeriodItem[]>(PARTNERSHIPS.PERIODS, {
    params: { yearFilter },
  });
};

export const getStudyPlanVersionOffersRequest = () => {
  return request<StudyPlanVersionOfferItem[]>(PARTNERSHIPS.OFFERS);
};
